import React from "react";
import Link from "next/link";
import Share from "./Share";
import Toggle from "./Toggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeOpen,
  faHeart,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import { IoRadioSharp } from "react-icons/io5";
// import Subscription from "./subscription";
import styles from "../styles/Home.module.css";

const Footer = () => {
  const { setQueryState } = Toggle();

  const Email = "radio.bruce@yahoo.com";

  return (
    <div
      className="allradios-wrapper allradios-wrapper__footer"
      style={{
        marginTop: "2em",
        padding: "0px",
        background: "#363647",
      }}
    >
      <div className={styles.grid} style={{ margin: "auto" }}>
        <div className="footer-wrapper">
          {/* <Subscription /> */}
          <div className="footer__container">
            <div className="footer-content">
              <span className="footer-title">
                <p>Share On</p>
              </span>
              <Share />

              <span className="copyright">
                <Link href="/" legacyBehavior>
                  <a
                    style={{ minHeight: "48px" }}
                    onClick={() => setQueryState(false)}
                  >
                    <p style={{ color: "#fff" }}>
                      &#xA9;2025{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: ".3rem",
                        }}
                      >
                        <IoRadioSharp
                          style={{ fontSize: "22px", color: "chartreuse" }}
                        />{" "}
                        | <span style={{ color: "#fff" }}>radioBruce</span>{" "}
                      </span>
                    </p>
                  </a>
                </Link>
                <a
                  href="https://www.emmanuelbugyei.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ minHeight: "48px" }}
                >
                  <p
                    style={{
                      margin: "0",
                      minHeight: "48px",
                      minWidth: "81px",
                      color: "#fff",
                    }}
                  >
                    created with{" "}
                    <span style={{ color: "red" }}>
                      <FontAwesomeIcon icon={faHeart} />
                    </span>{" "}
                    by <span style={copyRight}>Stbugyei</span>
                  </p>
                </a>
              </span>
            </div>

            <div className="footer-content">
              <span className="footer-title">
                <p>Contact Us</p>
              </span>

              <a href={`mailto:${Email}`} style={social}>
                <p
                  style={{
                    margin: "0",
                    minHeight: "48px",
                    textShadow: "none",
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelopeOpen} /> Email
                </p>
              </a>

              <Link href="/addstation" legacyBehavior>
                <a>
                  <p style={{ minHeight: "48px", textShadow: "none" }}>
                    Submit your radio
                  </p>
                </a>
              </Link>

              <a href={`mailto:${Email}`} style={social}>
                <p
                  style={{
                    margin: "0",
                    minHeight: "48px",
                    textShadow: "none",
                  }}
                >
                  <FontAwesomeIcon icon={faShare} /> Report a broken stream or
                  request to update Information.
                </p>
              </a>
            </div>

            <div className="footer-content">
              <div className="footer-title">
                <Link href="/" legacyBehavior>
                  <a
                    onClick={() => setQueryState(false)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: ".3rem",
                    }}
                  >
                    <IoRadioSharp
                      style={{ fontSize: "40px", color: "chartreuse" }}
                    />{" "}
                    | <span style={{ color: "#fff" }}>radioBruce</span>
                  </a>
                </Link>
              </div>
              <p style={{ textShadow: "none" }}>
                Listen to live online radio from Ghana and around the world in
                the comfort of your home, office, car, anywhere for free. You
                can as well play games from Casual Games Collection
              </p>
              <div style={{ color: "#fff" }}>
                <Link href="/privacy" legacyBehavior>
                  <a>
                    <p style={{ minHeight: "48px", marginTop: "20px" }}>
                      <strong>Privacy</strong>
                    </p>
                  </a>
                </Link>
                <Link href="/cookies" legacyBehavior>
                  <a>
                    <p style={{ minHeight: "48px" }}>
                      <strong>Cookies</strong>
                    </p>
                  </a>
                </Link>
                <Link href="/dmca" legacyBehavior>
                  <a>
                    <p style={{ minHeight: "48px" }}>
                      <strong>DMCA</strong>
                    </p>
                  </a>
                </Link>
                <Link href="/disclaimer" legacyBehavior>
                  <a>
                    <p style={{ minHeight: "48px" }}>
                      <strong>Disclaimer</strong>
                    </p>
                  </a>
                </Link>
              </div>

              <div className="copyright-wrapper">
                <Link href="/" onClick={() => setQueryState(false)}>
                  <p style={{ minHeight: "48px" }}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: ".3rem",
                        color: "#fff",
                      }}
                    >
                      &#xA9;2025{" "}
                      <IoRadioSharp
                        style={{ fontSize: "22px", color: "chartreuse" }}
                      />{" "}
                      | <span style={{ color: "#fff" }}>radioBruce</span>{" "}
                    </span>
                  </p>
                </Link>
                <a
                  href="https://www.emmanuelbugyei.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p
                    style={{
                      margin: "0",
                      minHeight: "48px",
                      minWidth: "81px",
                      color: "#fff",
                    }}
                  >
                    created with{" "}
                    <span style={{ color: "red" }}>
                      <FontAwesomeIcon icon={faHeart} />
                    </span>{" "}
                    by <span style={copyRight}>Stbugyei</span>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;

const copyRight = {
  minHeight: "50px",
  fontWeight: "bold",
  textTransform: "uppercase",
  color: "#fff",
};

const social = {
  minWidth: "153px",
  minHeight: "50px",
  display: "flex",
  alignItems: "center",
  gap: ".3rem",
  margin: "0",
};
